function makeRoad(seed) {
  const cells = new Array(241).fill('0');
  cells[0] = '';
  for (let row = 0; row < 6; row += 1) {
    for (let col = 0; col < 28 + seed; col += 1) {
      const index = col + row * 40 + 1;
      const score = (col * 7 + row * 11 + seed * 13) % 23;
      if (score > 10) continue;
      const banker = ((col * 5 + row * 3 + seed * 7) % 13) < 7;
      const tie = ((col * 3 + row + seed) % 17) === 0;
      cells[index] = tie ? (banker ? 'C1' : 'D1') : (banker ? 'A' : 'B');
    }
  }
  return cells.join('@');
}

function makeDerivedRoad(seed, redCode, blueCode, startRow = 0) {
  const cells = new Array(241).fill('0');
  cells[0] = '';
  for (let row = startRow; row < 6; row += 1) {
    for (let col = 0; col < 30 + seed; col += 1) {
      if (((col * 7 + row * 11 + seed * 13) % 23) >= 9) continue;
      cells[col + row * 40 + 1] = ((col * 5 + row * 3 + seed) % 13) < 7 ? redCode : blueCode;
    }
  }
  return cells.join('@');
}

function makeBeadRoad(seed) {
  const cells = new Array(121).fill('0');
  cells[0] = '';
  for (let row = 0; row < 6; row += 1) {
    for (let col = 0; col < 15; col += 1) {
      if (((col * 5 + row * 9 + seed) % 17) > 10) continue;
      const score = (col * 3 + row * 5 + seed) % 12;
      cells[col + row * 20 + 1] = score < 5 ? 'A' : (score < 10 ? 'B' : 'C');
    }
  }
  return cells.join('@');
}

export function createDemoSnapshot(username = '00000005') {
  const counts = [
    [28, 24, 5],
    [31, 30, 7],
    [12, 15, 2],
    [25, 19, 4]
  ];
  const timers = [18, 9, 23, 15];
  const tables = counts.map((count, index) => ({
    Name: `VIP ${index + 1}`,
    Countdown: timers[index],
    LastBootNum: 18 + index,
    LastSetNum: 36 + index,
    LastSetID: 9000 + index,
    BaccaratPool: {
      Banker: 124800 - index * 8600,
      Player: 86500 - index * 5100,
      Tie: 12400 - index * 700,
      BankerPair: 5700 - index * 300,
      PlayerPair: 4900 - index * 260
    },
    NewsList: [{ NewsContent: '欢迎进入永利贵宾大厅，请选择桌台进入游戏，祝您游戏愉快。' }]
  }));
  const analysis = counts.map((count, index) => {
    const mainDalu = makeRoad(index + 1);
    const smallRoads = [
      makeDerivedRoad(index + 2, 'A', 'B', 0),
      makeDerivedRoad(index + 3, 'C', 'D', 0),
      makeDerivedRoad(index + 4, 'E', 'F', 0)
    ];
    return {
      Banker: count[0],
      Player: count[1],
      Tie: count[2],
      MainLuZhu: makeBeadRoad(index + 1),
      MainDalu: mainDalu,
      MainXiaoLu: smallRoads,
      ZhuangWenLu: { LuZhu: makeBeadRoad(index + 5), DaLu: mainDalu, XiaoLu: smallRoads },
      XianWenLu: { LuZhu: makeBeadRoad(index + 8), DaLu: mainDalu, XiaoLu: smallRoads },
      WenLuStr: ['A', 'B', 'C', 'D', 'E', 'F']
    };
  });
  return {
    user: {
      Name: username || '00000005',
      AccountMoney: 595426.35,
      UserLimt: [{ MainMin: 100, MainMax: 50000, TieMin: 100, TieMax: 10000, PairMin: 100, PairMax: 5000 }]
    },
    tables,
    analysis,
    dateParts: [2026, 9, 24],
    session: { sessionId: 'demo-session', reconnectTicket: '' }
  };
}
